import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import VisibilitySensor from 'react-visibility-sensor';
import { styled } from '@linaria/react';
import { NoResults } from 'components/SearchUnavailability/NoResults';
import { getPaginationContext } from 'middleware/analytics/selectors';
import { Button } from '@daedalus/atlas/Button';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Icon } from '@daedalus/atlas/Icon';
import { Spinner } from '@daedalus/atlas/Spinner';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, AnalyticsContext, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { PaginationState } from '../usePagination';
const SPINNER_SIZE = 24;
const SpinnerWrapper = /*#__PURE__*/styled('div')({
  name: "SpinnerWrapper",
  class: "sb82c29",
  propsAsIs: false
});
const NoResultsWrapper = /*#__PURE__*/styled('div')({
  name: "NoResultsWrapper",
  class: "nxwtds",
  propsAsIs: false
});
type PaginationFooterProps = {
  paginationState: PaginationState;
  onLoadMore: () => void;
};
export const PaginationFooter = ({
  paginationState,
  onLoadMore
}: PaginationFooterProps) => {
  const dispatch = useDispatch();
  const [noMoreSensorIsEnabled, setNoMoreSensorIsEnabled] = useState(true);
  const paginationContext = useSelector(getPaginationContext);
  const onNoMoreResultsMessageView = useCallback(() => {
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.SearchResultsEnd,
      action: Action.Viewed,
      analyticsContext: {
        [AnalyticsContext.PaginationContext]: paginationContext
      }
    }));
    setNoMoreSensorIsEnabled(false);
  }, [dispatch, paginationContext]);
  if (paginationState === PaginationState.Loading) return <SpinnerWrapper>
        <Spinner size={SPINNER_SIZE} />
      </SpinnerWrapper>;
  if (paginationState === PaginationState.HasMore) return <Flex.Row justifyContent="center">
        <Button variant="secondary" dataId="LoadMoreButton" onClick={onLoadMore} iconEnd={<Icon name="ArrowDown" />}>
          <FormattedMessageWrapper id="loadMore" dataId="loadMore" defaultMessage="Load more" />
        </Button>
      </Flex.Row>;
  if (paginationState === PaginationState.NoMore) {
    return <VisibilitySensor
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // It will be fixed once this PR, https://github.com/joshwnj/react-visibility-sensor/pull/180, has been merged
    partialVisibility="bottom" active={noMoreSensorIsEnabled} onChange={isVisible => isVisible && onNoMoreResultsMessageView()}>
        <NoResultsWrapper>
          <NoResults buttonVariant="secondary" />
        </NoResultsWrapper>
      </VisibilitySensor>;
  }
  return null;
};

require("./index.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");